import React, { useEffect, useState } from 'react';
import { getSecciones } from '../../api/secciones';
import styles from '../../styles/BajaReactivacionStyles/BajaReactivacion.module.css';

function SearchFilters({ filters, onFilterChange, searchTerm, onSearch, onBuscar }) {
  const [secciones, setSecciones] = useState([]);

  useEffect(() => {
    getSecciones().then(setSecciones).catch(() => setSecciones([]));
  }, []);

  return (
    <div className={styles.searchSection}>
      <div className={styles.searchHeader}>
        <div className={styles.searchIcon}>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
          </svg>
        </div>
        <h2 className={styles.searchTitle}>Búsqueda de Estudiante</h2>
      </div>
      
      <div className={styles.filtersRow}>
        <div className={styles.filterGroup}>
          <label className={styles.filterLabel}>Sección</label>
          <select
            className={styles.filterSelect}
            value={filters.seccion}
            onChange={(e) => onFilterChange('seccion', e.target.value)}
          >
            <option value="">Todas</option>
            {secciones.map((s) => (
              <option key={s.id} value={s.id}>{s.nombre}</option>
            ))}
          </select>
        </div>
        
        <div className={styles.searchInputContainer}>
          <div className={styles.searchInputIcon}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <circle cx="11" cy="11" r="8"/>
              <path d="m21 21-4.35-4.35"/>
            </svg>
          </div>
          <input
            type="text"
            className={styles.searchInput}
            placeholder="Buscar por Matrícula o Nombre..."
            value={searchTerm}
            onChange={(e) => onSearch(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') onBuscar(); }}
          />
        </div>
        
        <button className={styles.searchButton} onClick={onBuscar}>
          BUSCAR
        </button>
      </div>
    </div>
  );
}

export default SearchFilters;
